compiler('#delivery_tracking_package_name_wrapper', (element) => {
  const save_checkbox = document.querySelector("#delivery_tracking_save_as_shipping_packaging");

  save_checkbox.addEventListener('change', function() {
    if (save_checkbox.checked) {
      element.classList.remove('d-none');
    } else {
      element.classList.add('d-none');
    }
  });
});
